<template>
  <custom-modal
    :title="routingRecord ? 'Route missed calls to the voicemail' : 'Play recording'"
    :on-save="onClickSave"
    :on-cancel="onClickCancel"
    :error="error"
    :saving="storingAudio || initalLoading"
    :disabled="disableSave"
    :custom-style="customStyle"
    content-style="flex: 1;"
    custom-header-style="
      padding: 15px 20px;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      -webkit-border-top-right-radius: 20px;
      -webkit-border-top-left-radius: 20px;
      -moz-border-radius-topleft: 20px;
      -moz-border-radius-topright: 20px;"
  >
    <div v-if="routingRecord" class="external-header">
      <div class="toggle-button">
        <toggle-button :value="routeToVoiceMail" :width="38" :height="24" color="#008619" @change="handleToggle" />
        <p>Turned {{ routeToVoiceMail ? 'On' : 'Off' }}</p>
      </div>
      <div class="greeting-type">
        <ul>
          <li :class="{ active: defaultGreeting }" @click="defaultGreeting = true">
            Default Greeting
          </li>
          <li :class="{ active: !defaultGreeting }" @click="defaultGreeting = false">
            Custom Greeting
          </li>
        </ul>
      </div>
    </div>
    <div v-if="routeToVoiceMail && !defaultGreeting" class="tab-container">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="tab"
        :class="{ 'tab selected': selected === tab }"
        @click="onClickTab(tab)"
      >
        {{ tab }}
      </div>
    </div>

    <div v-if="routeToVoiceMail && !defaultGreeting && selected === 'Upload file'">
      <play-recording-upload-file
        ref="uploadedAudio"
        :uploadedFile="uploadedFile"
        :uploadedDuration="uploadedDuration"
        :initalLoading="initalLoading"
        :set-error="setError"
        @enable-save="switchUploadedAudioSaving"
        @delete-audio="deleteUploadedAudio"
        @store-audio="storeUploadedAudio"
      />
    </div>

    <div v-if="routeToVoiceMail && !defaultGreeting && selected === 'Record audio'">
      <play-recording-record-audio
        ref="recordAudio"
        :recordedFile="recordedFile"
        :recordedDuration="recordedDuration"
        :initalLoading="initalLoading"
        :set-error="setError"
        @enable-save="switchRecordedAudioSaving"
        @store-audio="storeRecordedAudio"
        @delete-audio="deleteRecordedAudio"
      />
    </div>

    <div v-if="routeToVoiceMail && defaultGreeting">
      <play-recording-default-audio ref="defaultAudio" :initalLoading="initalLoading" :set-error="setError" />
    </div>
  </custom-modal>
</template>

<script>
import axios from 'axios';
import { ToggleButton } from 'vue-js-toggle-button';

import CustomModal from '@/components/CustomModal';
import PlayRecordingRecordAudio from './PlayRecordingRecordAudio';
import PlayRecordingDefaultAudio from './PlayRecordingDefaultAudio';
import PlayRecordingUploadFile from './PlayRecordingUploadFile';

export default {
  name: 'PlayRecordingModal',
  components: {
    ToggleButton,
    CustomModal,
    PlayRecordingRecordAudio,
    PlayRecordingUploadFile,
    PlayRecordingDefaultAudio
  },
  props: {
    onSave: Function,
    onCancel: Function,
    dataType: String,
    audioType: String,
    callMenu: Object,
    currentKey: Number,
    storingAudio: Boolean
  },
  data() {
    return {
      initalLoading: false,
      selected: 'Record audio',
      tabs: ['Upload file', 'Record audio'],
      defaultGreeting: false,
      routeToVoiceMail:   true,
      uploadedFile: null,
      uploadedDuration: 0,
      recordedFile: null,
      recordedDuration: 0,
      canSaveUploadedAudio: false,
      canSaveRecordedAudio: false,
      text: '',
      error: null
    };
  },
  computed: {
    customStyle() {
      return this.routingRecord
        ? 'width: 570px; height: 420px; overflow: visible;'
        : 'width: 570px; height: 355px; overflow: visible;';
    },
    disableSave() {
      if (!this.routeToVoiceMail || this.defaultGreeting) {
        return false;
      }

      if (this.selected === 'Record audio') {
        if (this.recordedFile && this.canSaveRecordedAudio) {
          return false;
        }
      } else if (this.selected === 'Upload file') {
        if (this.uploadedFile && this.canSaveUploadedAudio) {
          return false;
        }
      } else if (this.selected === 'Text to audio') {
        if (this.text.length > 0) {
          return false;
        }
      }

      return true;
    },
    routingRecord() {
      return this.audioType === 'number_routing' || this.audioType === 'direct_routing';
    }
  },
  async created() {
    let persistent = {};
    this.initalLoading = true;

    if (this.audioType === 'callmenu' || this.audioType === 'voicemail' || this.audioType === 'direct_routing') {
      persistent = this.callMenu[this.dataType].target;
      console.log(this.callMenu)
   
   
   
      if (this.audioType === 'direct_routing') {
        this.defaultGreeting = persistent.isDefault === undefined || persistent.isDefault === true ? true : false;
        this.routeToVoiceMail = persistent.isEnabled === undefined || persistent.isEnabled === true ? true : false;
      }
    } else {
    
      persistent = this.callMenu[this.dataType].numbers.find((num) => num.key === this.currentKey).target;
       

       
  
  
      if (this.audioType === 'number_routing') {
        this.defaultGreeting = persistent.isDefault === undefined || persistent.isDefault === true ? true : false;
        this.routeToVoiceMail = persistent.isEnabled === undefined || persistent.isEnabled === true ? true : false;
      }
    }
                                          console.log(persistent)
    if (persistent && persistent.tab) {
      this.selected = persistent.tab;
      let uploaded = null;

      if (persistent.url) {
        const response = await axios({
          url: persistent.url,
          method: 'GET',
          responseType: 'blob'
        });
        uploaded = response.data;
      }

      if (persistent.tab === 'Upload file') {
        this.uploadedFile = uploaded;
        this.uploadedDuration = persistent.duration;
      } else if (persistent.tab === 'Record audio') {
        this.recordedFile = uploaded;
        this.recordedDuration = persistent.duration;
      } else {
        this.text = persistent.text;
      }
    }
    this.initalLoading = false;
  },
  methods: {
    handleToggle() {
      this.routeToVoiceMail = !this.routeToVoiceMail;
    },

    setError(message = null) {
      this.error = message;
    },

    storeRecordedAudio(file, duration) {
      this.recordedFile = file;
      this.recordedDuration = duration;
    },

    deleteRecordedAudio() {
      this.recordedFile = null;
      this.recordedDuration = 0;
    },

    switchRecordedAudioSaving(canSave = false) {
      this.canSaveRecordedAudio = canSave;
    },

    storeUploadedAudio(file, duration) {
      this.uploadedFile = file;
      this.uploadedDuration = duration;
    },

    async deleteUploadedAudio() {
      this.uploadedFile = null;
      this.uploadedDuration = 0;
    },

    switchUploadedAudioSaving(canSave = false) {
      this.canSaveUploadedAudio = canSave;
    },

    /**
     * Stop audio playback (reuse the code)
     */
    stopPlayback() {
      if (!this.routeToVoiceMail) {
        return;
      }
      if (this.defaultGreeting) {
        //
      } else {
        if (this.selected === 'Upload file') {
          this.$refs.uploadedAudio.stopPlayback();
        } else if (this.selected === 'Record audio') {
          this.$refs.recordAudio.stopPlayback();
        }
      }
    },

    /**
     * On "Cancel" button click
     * @returns {Function}
     */
    async onClickCancel() {
      // stop the playback first
      this.stopPlayback();

      // and call the passed function
      return this.onCancel();
    },

    /**
     * On "Save" button click
     * @returns {Function}
     */
    async onClickSave() {
      // stop the playback first
      this.stopPlayback();

      // update user record in Vuex: save call flow
      const isDefault = this.routingRecord && this.defaultGreeting;
      const isEnabled = this.routeToVoiceMail;
            let persistent = {};
  

   if (this.audioType === 'callmenu' || this.audioType === 'voicemail' || this.audioType === 'direct_routing') {
      persistent = this.callMenu[this.dataType].target;
    
    } else {
      persistent = this.callMenu[this.dataType].numbers.find((num) => num.key === this.currentKey).target;
    
    }
   
        let tab ; 
    
   
   
   
   
   
      

   
   
      if(isDefault)
      {
        tab = ''

      }
      else
      {
          tab = this.selected
      }
   
    let file  ;
     
    
      if(tab === 'Upload file' )
      {
          file = this.uploadedFile 
      }
      else
      {

          if(tab === 'Record audio' )
      {
         file = this.recordedFile 
     

      }
      else
      {
         file =  null;
     

      }
   


      }
   
    
     
     
               let text   ;
       if(tab === 'Text to audio' )
      {
                 text = this.text  
      }
      else
      {
               text =  null;

      }
   
   
    
    
    
    
               let duration                   
   
      if(tab === 'Upload file' )
      {
                           duration =
        this.uploadedDuration  ;


      }
      else
      {
           if(tab === 'Record audio' )
      {
         duration =
this.recordedDuration 

      }
      else
      {
         duration = 0;

      }
   

      }
  
   
   
   
      let custom  = ""
    
         if(persistent)
      {
        if(persistent.custom)
        {
          custom = persistent.custom;
        }
      }
   

    
    
    
       let   customTarget  = ""
        if(persistent)
      {
           if(persistent.customTarget )
      {
  customTarget =         persistent.customTarget
      }
   

      }
     


     
     
        let  csText = ""
           if(persistent)
      {
           if(persistent.csText )
      {
   csText =         persistent.csText
      }
   

      }
     

        
        let tabs = ""
   

          if(isDefault)
      {
        tabs = persistent.tab

      }
      else
      {
         tabs = this.selected
      }
   
           let setsCustom = false;
        
        
         
        let  csTabs  =    "" 


                        if(persistent)
      {
           if(persistent.csTabs )
      {
   csTabs =         persistent.csTabs
      }
   

      }
     
      
        if(!isDefault)
    
        {
          if(isEnabled)
          {
              if(persistent)
              {
          setsCustom = true;                  

                 custom = persistent.url
          customTarget = file,
          csText = duration;
          csTabs = isEnabled; 



              }            
            









            
          }

     

        }
     
      let target = ""
         if(persistent)
      {
           if(persistent.url )
      {
   target =          persistent.url
      }
   

      }
     


      const record = { tab: tabs    , file, text, customTarget, setsCustom, csText, duration, custom,  target:  target , isDefault, isEnabled };

      // call the passed function
      return this.onSave(this.currentKey, record);
    },

    onClickTab(tab = '') {
      if (this.selected === tab) {
        return;
      }
      this.setError('');
      this.stopPlayback();
      this.selected = tab;
    }
  }
};
</script>

<style scoped lang="scss">
.external-header {
  padding: 10px 20px 20px 20px;
  background: #f4f5f7;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .toggle-button {
    display: flex;
    align-items: center;

    p {
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.01em;
      color: #606c82;
      margin-left: 10px;
    }
  }

  .greeting-type {
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      display: inline-flex;
      background: #e0e2e8;
      border-radius: 4px;
      li {
        border: 1px solid transparent;
        transition: 0.3s;
        font-size: 14px;
        font-weight: 500;
        color: #98a0ad;
        padding: 7px 20px;
        display: block;
        cursor: pointer;
      }
      li.active {
        background: #ffffff;
        border: 1px solid #dfe1e5;
        box-shadow: 0px 4px 10px rgba(26, 42, 75, 0.1);
        border-radius: 4px;
        color: #008619;
      }
    }
  }
}
.tab-container {
  margin-top: 25px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  .tab {
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: -0.02em;
    color: $colorPlaceholder;
    cursor: pointer;
    width: 110px;
    &.selected {
      color: #374561;
      border-bottom: 1px solid #374561;
    }
    &.disabled {
      cursor: not-allowed;
      color: #cdd5e2;
    }
  }
}
</style>
